<template>
 <div>
  <div class="block block-link-shadow text-center">
    <div class="block-content block-content-full block-sticky-options pt-30">
      <div class="block-options">
        <b-dropdown class="dropdown-no-btn" right>
          <template slot="button-content">
            <i class="fa fa-fw fa-ellipsis-v"></i>
          </template>
          <b-dropdown-item @click="openProductsTable">
            <i class="fa fa-fw fa-tag mr-5"></i>Producten
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <img class="img-avatar" :src="'/static/img/dropshipment/' + vendor.type + '.png'" alt="">
    </div>

    <div class="block-content block-content-full block-content-sm bg-body-light">
      <div class="font-w600 mb-5">{{vendor.name}}</div>
      <div class="font-size-sm text-muted">{{products.total}} producten in koppeling</div>
    </div>
    <div class="block-content">
      <div class="row items-push text-center">
        <div class="col-12" v-if="vendor.sync_interval === 'daily'">
          <div>
            <div class="mb-5"><i class="si si-like fa-2x"></i></div>
            <div class="font-size-sm text-muted">Synchroniseert dagelijks om {{vendor.sync_time}}</div>
          </div>
        </div>
        <div class="col-12" v-else>
          <div class="mb-5"><i class="si si-like fa-2x"></i></div>
          <div class="font-size-sm text-muted">Synchronisatie n.v.t.</div>
        </div>
      </div>
    </div>
  </div>
    <dropshipment-products-table v-if="showProductsTable" :vendor="vendor" @close="showProductsTable = false"></dropshipment-products-table>
</div>
</template>

<script>
import DropshipmentProductsTable from './DropshipmentProductsTable'

export default {
  components: {
    DropshipmentProductsTable
  },
  props: {
    vendor: Object
  },
  data () {
    return {
      products: {},
      showProductsTable: false
    }
  },
  methods: {
    loadProducts () {
      const params = {}

      params['filter[dropship]'] = this.vendor.type

      this.$http.get(`/products`, { params })
        .then((result) => {
          this.products = result.data
        })
        .catch(() => {
          this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het ophalen van de dropshipment producten. Probeer het opnieuw.`, 'error')
        })
    },
    openProductsTable () {
      this.showProductsTable = true
    }
  },
  created () {
    this.loadProducts()
  }
}
</script>



// WEBPACK FOOTER //
// DropshipmentWidget.vue?1946b2ca